import React, { useState } from 'react';
import { StyledLink, LoginFormWrapper, CommonPagesWrapper, CustomBasicInput, TextWrapper, LoginButton } from './Login.styles';
import { Box, Link, Typography } from '@mui/material';
import VerifyOtp from '../../components/VerifyOtp';
import api from '../../api/base';
import { login } from '../../api/paths';
import { LoginResponseType } from '../../api/paths.types';
import Acknowledge from './Acknowledge';
import useError from '../../hooks/useError';
import * as Sentry from '@sentry/browser';
import LoginContainer from './LoginContainer';
import { MainTheme } from '../../theme';

const Login = () => {
  const [authData, setAuthData] = useState<LoginResponseType | null>(null);
  const [step, setStep] = useState<'login' | 'verify' | 'acknowledge'>('login');
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const [handleError] = useError();

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post<LoginResponseType>(login, { email, password }, { headers: { authorization: '' } });
      Sentry.setUser({ email });
      setAuthData(data);
      setStep('verify');
    } catch (error: any) {
      handleError(error);
    }
    setLoading(false);
  };

  const backToLoginScreen = () => {
    setEmail('');
    setPassword('');
    setStep('login');
  };

  const setAcknowledgeUserPopup = () => {
    setStep('acknowledge');
  };

  return (
    <MainTheme forceTheme='dark'>
      <CommonPagesWrapper>
        <LoginContainer>
          {step === 'login'
              && (
                <>
                  <LoginFormWrapper onSubmit={handleLogin}>
                    <TextWrapper gap="8px">
                      <Typography variant='dsm' color="#F9FAFB" component="p">
                      Log in
                      </Typography>
                      <Typography variant="tmd" color="#98A2B3" component="p">
                      Welcome back! Please enter your details.
                      </Typography>
                    </TextWrapper>
                    <TextWrapper gap="20px" marginTop={'32px'}>
                      <CustomBasicInput
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder='Enter your email'
                        fullWidth
                        type={'email'}
                      />
                      <CustomBasicInput
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder='Enter your password'
                        fullWidth
                        type={'password'}
                      />
                    </TextWrapper>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="end"
                      width="100%"
                      mt={'24px'}
                    >
                      <Link component={StyledLink}
                        to="/forgot-password"
                        variant='tsm'
                        fontWeight={500}>
                        Forgot password
                      </Link>
                    </Box>
                    <Box width={'100%'} mt={'24px'}>
                      <LoginButton
                        variant="contained"
                        color="primary"
                        fullWidth
                        type="submit"
                        loading={loading}
                        loadingPosition="end"
                        size="large"
                      >
                        Log in
                      </LoginButton>
                    </Box>
                  </LoginFormWrapper>
                </>
              )}
          {step === 'verify' && authData && (
            <VerifyOtp
              setAcknowledgeUserPopup={setAcknowledgeUserPopup}
              authData={authData}
              backToLoginScreen={backToLoginScreen}
            />
          )}
          {step === 'acknowledge' && (
            <Acknowledge />
          )}
        </LoginContainer>
      </CommonPagesWrapper>
    </MainTheme>
  );
};

export default Login;
